/**
 * Products Domain - Urdu Translations
 * Flat structure (no nested 'products' wrapper) - namespace added by portal
 */

export const urTranslations = {
  title: 'مصنوعات',
  subtitle: 'SKUs، ویریئنٹس، اور کیٹیگریز کا انتظام کریں',
  // Unit labels (flat keys for UI components)
  packaging: {
    bags: 'بیگز',
    bulk: 'بلک',
  },
  bag: 'بیگ',
  bags: 'بیگز',
  bulk: 'بلک',
  ton: 'ٹن',
  tons: 'ٹن',
  perBag: 'فی بیگ',
  perTon: 'فی ٹن',
  addItem: 'آئٹم شامل کریں',
  addSku: 'SKU شامل کریں',
  editSku: 'SKU میں ترمیم کریں',
  addVariant: 'ویریئنٹ شامل کریں',
  editVariant: 'ویریئنٹ میں ترمیم کریں',
  skuDetails: 'SKU تفصیلات',
  variantDetails: 'ویریئنٹ تفصیلات',
  noSkus: 'کوئی SKU نہیں ملا',
  noVariants: 'کوئی ویریئنٹ نہیں ملا',
  noCategories: 'کوئی کیٹیگری نہیں ملی',
  searchPlaceholder: 'مصنوعات تلاش کریں...',
  overview: 'جائزہ',

  // Timeline
  timelineTab: 'ٹائم لائن',
  timelineEmpty: 'ابھی تک کوئی واقعہ نہیں',
  timelineEmptyDesc: 'اس ویریئنٹ، اس کے SKU اور کیٹیگریز میں تبدیلیاں یہاں ظاہر ہوں گی',
  selectVariant: 'ویریئنٹ منتخب کریں',

  // Stats
  stats: {
    totalSkus: 'کل SKUs',
    activeSkus: 'فعال SKUs',
    totalVariants: 'کل ویریئنٹس',
    activeVariants: 'فعال ویریئنٹس',
    totalCategories: 'کیٹیگریز',
  },

  // Form fields
  form: {
    name: 'نام',
    nameEn: 'نام (انگریزی)',
    nameAr: 'نام (عربی)',
    description: 'تفصیل',
    descriptionEn: 'تفصیل (انگریزی)',
    descriptionAr: 'تفصیل (عربی)',
    categories: 'کیٹیگریز',
    selectCategories: 'کیٹیگریز منتخب کریں',
    sku: 'SKU',
    selectSku: 'SKU منتخب کریں',
    variantCode: 'ویریئنٹ کوڈ',
    variantCodePlaceholder: 'مثال: VAR-001',
    barcode: 'بارکوڈ',
    weight: 'وزن (کلوگرام)',
    packaging: 'پیکیجنگ کی قسم',
    portalAvailability: 'دستیاب پلیٹ فارم',
    deliveryGrouping: 'ڈیلیوری گروپنگ رول',
    isActive: 'فعال',
    sapIntegration: 'SAP انٹیگریشن',
    sapMaterialCode: 'SAP میٹیریل کوڈ',
    sapMaterialCodePlaceholder: 'مثلاً: 000000000050000010',
    sapStorageLocationCode: 'SAP سٹوریج لوکیشن کوڈ',
    sapStorageLocationCodePlaceholder: 'مثلاً: Z017',
    sapDescription: 'SAP تفصیل',
    sapBaseUnit: 'SAP بنیادی اکائی',
  },

  portalAvailability: {
    ecommerce: 'ای کامرس',
    portal: 'پورٹل',
    both: 'دونوں',
  },

  // Packaging types (nested for form select options)
  packagingTypes: {
    bags: 'بیگز',
    bulk: 'بلک',
  },

  // Delivery grouping rules
  deliveryGrouping: {
    allowMixed: 'مخلوط اجازت',
    allowMixedDesc: 'دوسری پیکیجنگ اقسام کے ساتھ ڈیلیور کیا جا سکتا ہے',
    requireSame: 'یکساں ضروری',
    requireSameDesc: 'صرف یکساں پیکیجنگ قسم کے ساتھ ڈیلیور ہونا ضروری ہے',
  },

  // Validation messages
  validation: {
    nameRequired: 'نام ضروری ہے',
    codeRequired: 'ویریئنٹ کوڈ ضروری ہے',
    barcodeRequired: 'بارکوڈ ضروری ہے',
    weightRequired: 'وزن ضروری ہے',
    weightMin: 'وزن کم از کم 1 کلوگرام ہونا چاہیے',
    skuRequired: 'SKU ضروری ہے',
    packagingRequired: 'پیکیجنگ کی قسم ضروری ہے',
  },

  // Delete confirmations
  delete: {
    confirmSku: 'کیا آپ واقعی اس SKU کو حذف کرنا چاہتے ہیں؟',
    confirmVariant: 'کیا آپ واقعی اس ویریئنٹ کو حذف کرنا چاہتے ہیں؟',
    warning: 'یہ عمل واپس نہیں کیا جا سکتا۔ تمام متعلقہ ویریئنٹس بھی ہٹا دیے جائیں گے۔',
    variantWarning:
      'یہ عمل واپس نہیں کیا جا سکتا۔ ویریئنٹ تمام دستیابی میٹرکس سے ہٹا دیا جائے گا۔',
  },

  // Success messages
  success: {
    skuCreated: 'SKU کامیابی سے بنایا گیا',
    skuUpdated: 'SKU کامیابی سے اپ ڈیٹ ہوا',
    skuDeleted: 'SKU کامیابی سے حذف ہوا',
    variantCreated: 'ویریئنٹ کامیابی سے بنایا گیا',
    variantUpdated: 'ویریئنٹ کامیابی سے اپ ڈیٹ ہوا',
    variantDeleted: 'ویریئنٹ کامیابی سے حذف ہوا',
  },

  // Error messages
  error: {
    fetchFailed: 'مصنوعات حاصل کرنے میں ناکامی',
    createFailed: 'مصنوعات بنانے میں ناکامی',
    updateFailed: 'مصنوعات اپ ڈیٹ کرنے میں ناکامی',
    deleteFailed: 'مصنوعات حذف کرنے میں ناکامی',
  },

  // Filters
  filter: {
    all: 'تمام',
    active: 'فعال',
    inactive: 'غیر فعال',
    allPackaging: 'تمام پیکیجنگ',
    allCategories: 'تمام کیٹیگریز',
  },

  // Certificates section
  certificates: {
    title: 'سرٹیفکیٹس',
    refresh: 'تازہ کریں',
    addCertificate: 'سرٹیفکیٹ شامل کریں',
    searchPlaceholder: 'سرٹیفکیٹس تلاش کریں...',
    typeFilter: 'قسم',
    allTypes: 'تمام اقسام',
    typeGeneral: 'عام',
    typeVariant: 'متغیر',
    allStatuses: 'تمام حالتیں',
    statusActive: 'فعال',
    statusInactive: 'غیر فعال',
    colTitle: 'عنوان',
    colType: 'قسم',
    colLinkedVariant: 'منسلک متغیر',
    colFile: 'فائل',
    colStatus: 'حالت',
    colActions: 'اقدامات',
    noCertificates: 'کوئی سرٹیفکیٹ نہیں ملا',
    addFirstCertificate: 'اپنا پہلا سرٹیفکیٹ شامل کریں',
    typeGeneralLabel: 'عام',
    typeVariantLabel: 'متغیر',
    typeUnlinkedLabel: 'غیر منسلک',
    noFile: 'کوئی فائل نہیں',
    deleteConfirm: '"$1" حذف کریں؟',
    editCertificate: 'سرٹیفکیٹ ترمیم کریں',
    fieldTitle: 'عنوان',
    titlePlaceholder: 'مثال: ISO 9001:2015',
    titleRequired: 'عنوان ضروری ہے',
    fieldDescription: 'تفصیل',
    descriptionPlaceholder: 'اختیاری تفصیل',
    fieldGeneralCert: 'عام سرٹیفکیٹ',
    generalCertHint: '"ہمارے بارے میں" صفحے پر دکھایا جائے گا',
    fieldActive: 'فعال',
    activeHint: 'صارفین کو نظر آئے',
    fieldLinkedVariant: 'منسلک متغیر',
    selectVariantOptional: 'متغیر منتخب کریں (اختیاری)',
    fieldPdf: 'سرٹیفکیٹ PDF',
    uploadPdf: 'PDF اپ لوڈ کرنے کے لیے کلک کریں',
    onlyPdfAccepted: 'صرف PDF فائلیں قبول ہیں',
    uploadFailed: 'فائل اپ لوڈ ناکام۔ دوبارہ کوشش کریں۔',
    cancel: 'منسوخ',
    saveChanges: 'تبدیلیاں محفوظ کریں',
    createCertificate: 'سرٹیفکیٹ بنائیں',
  },

  // Table headers
  table: {
    name: 'نام',
    code: 'کوڈ',
    barcode: 'بارکوڈ',
    weight: 'وزن',
    packaging: 'پیکیجنگ',
    status: 'حالت',
    variants: 'ویریئنٹس',
    categories: 'کیٹیگریز',
    actions: 'اقدامات',
  },
}

export type ProductsTranslations = typeof urTranslations
